
import {
  defineComponent,
  onMounted,
  watch,
  shallowRef,
} from 'vue'

const VisGraph = require('./graphjs/visgraph.js')
const LayoutFactory = require('./graphjs/visgraph-layout.min')

export default defineComponent({
  props: {
    graphData: {
      type: Object,
      default: () => {}
    }
  },
  setup (props) {
    const graphContainer = shallowRef<HTMLDivElement>()
    const visGraph = shallowRef<any>(null)
    const config = {
      node: {
        label: {
          show: true,
          color: '250,250,250',
          font: 'normal 14px Microsoft YaHei',
          textPosition: 'Middle_Center',
          borderWidth: 0,
          wrapText: true
        },
        shape: 'circle',
        width: 30,
        height: 30,
        color: '62,160,250',
        borderColor: '62,160,250',
        borderWidth: 0,
        borderRadius: 0,
        lineDash: [0],
        alpha: 1,
        selected: {
          borderColor: '136,198,255',
          borderAlpha: 1,
          borderWidth: 3,
          showShadow: true,
          shadowColor: '136,198,255'
        },
      }
    }
    onMounted(() => {
      // eslint-disable-next-line no-undef
      visGraph.value = new VisGraph(graphContainer.value, config)
      visGraph.value.drawData(props.graphData)
      layoutCanvas()
      // 3、画布元素居中
      visGraph.value.setZoom('auto')// 自动缩放
    })
    watch(() => props.graphData, () => {
      visGraph.value.drawData(props.graphData)
      layoutCanvas()
      // 3、画布元素居中
      visGraph.value.setZoom('auto')// 自动缩放
    })
    // 执行布局算法
    function layoutCanvas () {
      const layout = new LayoutFactory(visGraph.value.getVisibleData()).createLayout('fastFR')
      console.log(layout)
      layout.initAlgo()
      let i = 0
      while (i++ < 300) {
        layout.runLayout()
      }
    }

    function exportImageDataURL (): string {
      // 官方提供的 saveImage 方法会触发自动下载, 和需求不符
      // 翻源码: https://gitee.com/baopengdu/GraphVis/blob/master/src/visgraph/visgraph.js
      // 找到的方法: getImageUrlData
      return visGraph.value.stage.thumbnail.getImageUrlData(2000, 2000, 'jpeg')
    }

    function zoomOut () {
      // TODO: 放大缩小
      console.log('**debug setZoom:', visGraph.value)
      visGraph.value.setZoom('zoomOut')
    }

    function zoomIn () {
      visGraph.value.setZoom('zoomIn')
    }

    return {
      zoomOut,
      zoomIn,
      graphContainer,
      exportImageDataURL,
      visGraph,
    }
  }
})
